export enum Permission {
    create = 'c',
    read = 'r',
    update = 'u',
    delete = 'd',
    approve = 'a',
    settings = 's',
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/auth/permission.ts